
export const gaPageLoad  = (product) => {

  const Productinfo = [];
  for (let datakey in product) {
    Productinfo.push({
      id: product[datakey].payload.product.id,
      name: product[datakey].payload.product.name,
      category: product[datakey].payload.product.prodType,
    });
  }

   window.dataLayer && window.dataLayer.push({
    "event": "designerPageLoad",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId": window.jostens.customer.number,
    "schoolName": window.jostens.customer.extendedName,
    "designerProductCategory": product.enhanced.payload.product.prodType,
    "designerOrderStepName":"Designer Viewed",
    "designerType": "Stole",
    "ecommerce": {
      "detail": {
        "actionField": {
          "list": "Product Detail Page:Stole Designer",
        },
        "products":Productinfo
      },
    },
  });
};

export const gaDesignerSubstep = (currentStep,
  selectedStage,setSelectedStage,selectedTemplate,substemNameBranding,brandingTab) => {
    if (currentStep >= 2) selectedStage = 'Your Stole'
     window.dataLayer && window.dataLayer.push({
    "event": "designerSubStepComplete",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId":window.jostens.customer.number,
    "schoolName":window.jostens.customer.extendedName,
    "designerProductSku":selectedTemplate.product.id,
    "designerProductCategory":selectedTemplate.product.prodType,
    "designerType": "Stole",
    "designerOrderStepName": "Designer Viewed",
    "designerStepName": selectedStage,
    "designerStepNumber": currentStep+1,
    "designerTotalSteps": 3,
    "designerSubStepName": substemNameBranding,
    "designerSubStepNumber":brandingTab+1,
   // "stepModification": "true",
  });
};

export const gaEmptyPositionPopup = (setSelectedStage,
  selectedStage,selectedTemplate,setsubstemNameZone,brandingTab) => {
    selectedStage = 'Your Stole'
    window.dataLayer && window.dataLayer.push({
    "event": "emptyPositionPopup",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId": window.jostens.customer.number,
    "schoolName": window.jostens.customer.extendedName,
    "designerProductSku":selectedTemplate.product.id,
    "designerProductCategory":selectedTemplate.product.prodType,
    "designerType": "Stole",
    "designerOrderStepName": "Designer Viewed",
    "designerStepNumber":setSelectedStage,
    "designerStepName": selectedStage,
    "designerTotalSteps": 3,
    "designerSubStepName": setsubstemNameZone,
    "designerSubStepNumber":brandingTab+1,
  });
};

export const gaEmptyPositionPopupInside = (
  currentStep,
  selectedStage,
  returnorcontinue,
  selectedTemplate,
  setsubstemNameZone
) => {
  if (currentStep >= 2) selectedStage = 'Your Stole'
  window.dataLayer && window.dataLayer.push({
    "event": "emptyPositionPopupClick",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId": window.jostens.customer.number,
    "schoolName": window.jostens.customer.extendedName,
    "designerProductSku": selectedTemplate.product.id,
    "designerProductCategory": selectedTemplate.product.prodType,
    "designerType": "Stole",
    "designerOrderStepName": "Designer Viewed",
    "designerStepName": "Your Stole",
    "designerStepNumber":3,
    "designerTotalSteps": 3,
    "designerSubStepName": setsubstemNameZone,
    "designerSubStepNumber":currentStep,
    "stolePopupClick":  returnorcontinue,
  });
};

export const gaSavaDesign 
  = (
    currentStep,
    selectedStage,
    selectedTemplate
  ) => {
  //  if(currentStep == 3) selectedStage = 'Review'
    if(currentStep === 2) selectedStage = 'Your Stole'

    if(currentStep === 3)
    {
      window.dataLayer && window.dataLayer.push({
    "event": "savedDesignComplete",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId": window.jostens.customer.number,
    "schoolName": window.jostens.customer.extendedName,
    "designerProductSku":selectedTemplate.product.id,
    "designerProductCategory":selectedTemplate.product.prodType,
    "designerType": "Stole",
    "designerOrderStepName": "Designer Viewed",
    "designerStepName": selectedStage,
    "designerStepNumber": 'Review',
    "designerTotalSteps": 3,
  });
}
else {
  window.dataLayer && window.dataLayer.push({
    "event": "savedDesignComplete",
    "pageType": "Product Detail Page:Stole Designer",
    "schoolType": window.jostens.customer.routerType,
    "schoolId": window.jostens.customer.number,
    "schoolName": window.jostens.customer.extendedName,
    "designerProductSku":selectedTemplate.product.id,
    "designerProductCategory":selectedTemplate.product.prodType,
    "designerType": "Stole",
    "designerOrderStepName": "Designer Viewed",
    "designerStepName": selectedStage,
    "designerStepNumber": currentStep+1,
    "designerTotalSteps": 3,
  });
}
};

export const gaDesignerStepComplete = (
  currentStep,
  selectedStage,
  selectedTemplate
) => {
  if (currentStep >= 2) selectedStage = 'Your Stole'
   window.dataLayer && window.dataLayer.push({
    'event': 'designerStepComplete',
    'pageType': 'Product Detail Page:Stole Designer',
    'schoolType': window.jostens.customer.routerType,
    'schoolId': window.jostens.customer.number,
    'schoolName': window.jostens.customer.extendedName,
    'designerType':'Stole',
    'designerOrderStepName':'Designer Viewed',
    'designerProductSku':selectedTemplate.product.id,
    'designerProductCategory':selectedTemplate.product.prodType,
    'designerStepName': selectedStage,
    'designerStepNumber': currentStep + 1,
    'designerTotalSteps': 3,
    //'subStepModification':'true'
  })
}

export const gaDesignerComplete = (selectedTemplate) => {
   window.dataLayer && window.dataLayer.push({
    'event': 'designerComplete',
    'pageType': 'Product Detail Page:Stole Designer',
    'schoolType': window.jostens.customer.routerType,
    'schoolId': window.jostens.customer.number,
    'schoolName': window.jostens.customer.extendedName,
    'designerType': 'Stole',
    'designerOrderStepName': 'Designer Complete',
    'designerProductSku': selectedTemplate.product.id,
    'designerProductCategory': selectedTemplate.product.prodType,
    //'stepModification':'true'
  })
}

export const gaAddToCart = (selectedTemplate) => {
  window.dataLayer && window.dataLayer.push({
    'event': 'addToCart',
    'pageType': 'Product Detail Page:Stole Designer',
    'schoolType': window.jostens.customer.routerType,
    'schoolId': window.jostens.customer.number,
    'schoolName':window.jostens.customer.extendedName,
    'designerType': 'Stole',
    'designerOrderStepName': 'Add to Cart',
    'designerProductSku': selectedTemplate.product.id,
    'designerProductCategory': selectedTemplate.product.prodType,
    'ecommerce': {
      'add': {
        'products': [
          {
            'id': selectedTemplate.product.id,
            'name': selectedTemplate.product.templateVariant,
            'category': selectedTemplate.product.prodType,
            'price': (selectedTemplate.product.configPrice+selectedTemplate.designSettings.data.upchargeAmt).toFixed(2),
            'quantity':1,
            'dimension49': window.jostens.customer.routerType,
            'dimension50': window.jostens.customer.number,
            'dimension60': window.jostens.customer.extendedName
          },
        ],
      },
    },
  })
}